import styled from 'styled-components'
import IconSearch from '../../assets/images/icons/search.svg'
import IconArrowUp from '../../assets/images/icons/arrow-up.svg'
import IconArrowDown from '../../assets/images/icons/arrow-down.svg'
import IconAlert from '../../assets/images/icons/alert.svg'

/* style */
/* style */

/* function */
const getIconContainerStyled = props => {
  let stylesIcon = ''
  switch(props['name']){
    case 'search' 
      : stylesIcon += `&:before { content: url(${IconSearch}); }`
      break;
    case 'arrow-up' 
      : stylesIcon += `&:before { content: url(${IconArrowUp}); }`
      break;
    case 'arrow-down' 
      : stylesIcon += `&:before { content: url(${IconArrowDown}); }`
      break;
    case 'alert'
      : stylesIcon += `&:before { content: url(${IconAlert}); }`
      break;
    default
      : break;
  }

  if(props['width']) stylesIcon += `
    &:before { 
      width: ${props['width']}; 
      height: ${props['width']};
    }
  `
  
  if(props['onClick']) stylesIcon += `
    cursor: pointer;
  `
  return stylesIcon
}
/* function */

/* component */
export const IconContainer = styled.i`
  ${getIconContainerStyled}
  &:before {
    display: grid;
  }
`
/* component */